<template>

  <div :id="_uid" class="ui modal" :class="modalSelector">
    <div class="ui header">
      {{ isCreating ? "Nova Alteração de Órgão" : "Editar Alteração de Órgão" }}
    </div>
    <div class="content">
      <div class="ui form">
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Nome <span class="red text">*</span></label>
            <input class="uppercase" v-model="change.name" @blur="change.name = $toUpperCase($event)">
          </div>     
        </div>
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Descrição <span class="red text">*</span></label>
            <text-editor ref="descriptionEditor" />
          </div>   
        </div> 
      </div>
    </div>
    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i>
        Cancelar
      </button>            
      <button class="ui blue button" @click="onConfirm()">
        <i class="checkmark icon"></i>
        {{ isCreating ? "Confirmar" : "Atualizar" }}
      </button>
    </div>
  </div>  

</template>

<script>

  import modalDialog from "@/mixins/modal-dialog"
  import TextEditor from "@/components/text-editor"

  export default {

    name: "OrganChangeFormModal",

    mixins: [modalDialog],
    
    data() {
      return {
        change: {},
      }
    },

    components: {
      TextEditor,
    },

    methods: {

      load(change) {

        this.change = {}
        
        this.$refs.descriptionEditor.clear()

        if (change)
          this.change = this.$cloneObject(change)

        if (this.change.descriptionContents)
          this.$refs.descriptionEditor.setContents(this.change.descriptionContents)  

        this.show()
      },

      onConfirm() {

        if (!this.change.name || this.$refs.descriptionEditor.isEmpty()) {
          this.$msg.info("Informe o nome e a descrição da alteração")
          return
        }

        const event = this.isCreating ? "onCreate" : "onUpdate"

        this.change.description = this.$refs.descriptionEditor.getText()
        this.change.descriptionContents = this.$refs.descriptionEditor.getContents({ toString: true })

        this.emit(event, this.$cloneObject(this.change))
      },
    },
  }

</script>